// @flow

import Pagination from './pagination';

export type Props = {
  count: number,
  pageLength: number,
  pageNumber: number,
  updateSearchParam: () => void,
  handlePreviousPage: () => void,
  handleNextPage: () => void,
};

export default Pagination;
